import NumberSuffix from '../modules/numberSuffixBuilder.js';

const gradeOptions = [
  { value: 1, label: NumberSuffix(1) },
  { value: 2, label: NumberSuffix(2) },
  { value: 3, label: NumberSuffix(3) },
  { value: 4, label: NumberSuffix(4) },
  { value: 5, label: NumberSuffix(5) },
  { value: 6, label: NumberSuffix(6) },
  { value: 7, label: NumberSuffix(7) },
  { value: 8, label: NumberSuffix(8) },
  { value: 9, label: NumberSuffix(9) },
  { value: 10, label: NumberSuffix(10) },
  { value: 11, label: NumberSuffix(11) },
  { value: 12, label: NumberSuffix(12) },
  { value: 'University', label: 'University' },
  { value: 'Other', label: 'Other' }
]

export default gradeOptions
